import React, { useEffect, useCallback } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { allAnnonceType } from "../../Redux/annonceReduce";
import { useDispatch } from "react-redux";
import Configuration from "../../configuration";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const MyCarousel = ({ deviceType, type, client }) => {

  const dispatch = useDispatch();
  var annee = localStorage.getItem("annee");
  const [entities, setEntities] = React.useState([]);

  const getCarousel = useCallback(async (type) => {
    var carousel = await dispatch(allAnnonceType({ type: type, annee: annee, client }));
    setEntities(carousel.payload);
  }, [dispatch]);

  useEffect(() => {
    getCarousel(type)
  }, [getCarousel])

  return (

    <Carousel
      swipeable={false}
      draggable={false}
      showDots={false}
      responsive={responsive}
      ssr={true} // means to render carousel on server-side.
      infinite={true}
      autoPlay={deviceType !== "mobile" ? true : false}
      autoPlaySpeed={2500}
      keyBoardControl={true}
      customTransition="all .5"
      transitionDuration={2500}
      containerClass="carousel-container"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      deviceType={deviceType}
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-40-px"
    >
      {entities.map((entity, index) => (
        <div key={index} className="carousel-items">
          <a href={client+"/detailsActualite/" + entity.id}>
            <img src={Configuration.BACK_BASEURL + "annonce/" + entity.image} alt={entity.titre} className="carousel-images" />
            {1 != 1 ? <div className="carousel-captions">{entity.titre}</div> : null}
          </a>
        </div>
      ))}
    </Carousel>
  );
};

export default MyCarousel;
